import React from 'react'

const StandingsDayTotals = ({submissions,measurement_type, days, showPrefix = false,showDayPrefix,tourney_type,day_array,length_measurement_symbol,weight_measurement_symbol,show_multi_day_fish_count,fish_record_result}) => {
  
  //console.log('Show prefix value passed:::', showPrefix);

  //console.log('Submission record passed for day totals::::',submissions);
  submissions = submissions ? submissions : []

  const dayTotals = (submissions, days, fish_record_result) => {
    if(measurement_type === 'length'){
      return [...Array(parseInt(days))].map((_, index) => {
        const totalLength = submissions
          .filter(s => s.day === index + 1)
          .map(x => parseFloat(x.fish_length))
          .reduce((a, b) => a + b, 0);

        // Debugging: Log the corresponding fish_record_result for the day
        const dayRecord = fish_record_result?.find(record => record.day === index + 1);
        console.log(`Day ${index + 1} Record in fish_record_result:`, dayRecord);

        return totalLength;
      });
    } else {
      return [...Array(parseInt(days))].map((_, index) => {
        const totalWeight = submissions
          .filter(s => s.day === index + 1)
          .map(x => parseFloat(x.fish_weight))
          .reduce((a, b) => a + b, 0);

        const dayRecord = fish_record_result?.find(record => record.day === index + 1);
        console.log(`Day ${index + 1} Record in fish_record_result:`, dayRecord);

        return totalWeight;
      });
    }
  };

  return (
    <>
    {
      dayTotals(submissions, days, fish_record_result).map((score, index) => {
        
        // Find the record for the current day
        const dayRecord = fish_record_result?.find(record => record.day === index + 1);
        const totalFish = dayRecord ? dayRecord.day_wise_fish_count_total_result : '0';

        return (
          <td key={index}>
            <div className="standings-day-score">
              {measurement_type === 'length' ? (
                score === 0 ? (
                  <center>
                    {showDayPrefix ? `Day ${index + 1}: ${score}` : score}
                    {length_measurement_symbol}
                  </center>
                ) : (
                  <center>
                    {showDayPrefix ? `Day ${index + 1}: ${score.toFixed(2)}` : score.toFixed(2)}
                    {length_measurement_symbol}
                  </center>
                )
              ) : score === 0 ? (
                <center>
                  {showDayPrefix ? `Day ${index + 1}: ${score}` : score}
                  {weight_measurement_symbol}
                </center>
              ) : (
                <center>
                  {showDayPrefix ? `Day ${index + 1}: ${score.toFixed(2)}` : score.toFixed(2)}
                  {weight_measurement_symbol}
                </center>
              )}

              {/* TP-400 jira card - Total's tab -  Display fish count total for the corresponding day in Day 1/Day 2 column*/}
              <div className="fish-count-total">
                {show_multi_day_fish_count == 1 && (tourney_type == 3 || tourney_type == 19) ? (totalFish != 0 ?(<center>Total {totalFish} fish</center>) :null) : null }
                
              </div>
            </div>
          </td>
        );
      })}
    </>
  );
}

export default StandingsDayTotals